import { Mark, mergeAttributes } from "@tiptap/core"

// Linear's label colours, so an area reads the same in the post as in Linear.
export const CHANGELOG_AREA_COLORS = [
	"#EAB308",
	"#06B6D4",
	"#F97316",
	"#5E6AD2",
	"#22C55E",
	"#A855F7",
	"#EC4899",
	"#94A3B8",
] as const

export function changelogAreaColor(area: string): string {
	let hash = 0
	for (const char of area.trim().toLowerCase()) {
		hash = (hash * 31 + char.charCodeAt(0)) >>> 0
	}
	return CHANGELOG_AREA_COLORS[hash % CHANGELOG_AREA_COLORS.length]!
}

const HEX_COLOR = /^#[0-9a-f]{6}$/i

// Inline styles only: the same markup goes into emails, where no stylesheet
// reaches. The dot is a gradient so the pill stays one span of plain text.
export function changelogAreaStyle(color: string): string {
	const dot = HEX_COLOR.test(color) ? color : CHANGELOG_AREA_COLORS[7]
	return [
		"display:inline-block",
		"padding:0 8px 0 19px",
		"margin-right:2px",
		"border:1px solid rgba(128,128,128,0.28)",
		"border-radius:999px",
		"font-size:0.85em",
		"font-weight:500",
		"line-height:1.6",
		"white-space:nowrap",
		"vertical-align:1px",
		`background-image:radial-gradient(circle at 9.5px 50%, ${dot} 3.5px, transparent 4px)`,
		"background-repeat:no-repeat",
	].join(";")
}

/** The product-area pill in front of a smaller changelog item. */
export const ChangelogAreaExtension = Mark.create({
	name: "changelogArea",
	inclusive: false,
	excludes: "_",

	addAttributes() {
		return {
			color: {
				default: CHANGELOG_AREA_COLORS[7],
				parseHTML: (element) =>
					element.getAttribute("data-changelog-area") ||
					CHANGELOG_AREA_COLORS[7],
				renderHTML: (attributes: { color?: string }) => ({
					"data-changelog-area": attributes.color,
					style: changelogAreaStyle(attributes.color ?? ""),
				}),
			},
		}
	},

	parseHTML() {
		return [{ tag: "span[data-changelog-area]" }]
	},

	renderHTML({ HTMLAttributes }) {
		return ["span", mergeAttributes(HTMLAttributes), 0]
	},
})
